import { render, staticRenderFns } from "./CreateTagForm.vue?vue&type=template&id=0f5ed10c&scoped=true"
import script from "./CreateTagForm.vue?vue&type=script&lang=js"
export * from "./CreateTagForm.vue?vue&type=script&lang=js"
import style0 from "./CreateTagForm.vue?vue&type=style&index=0&id=0f5ed10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ed10c",
  null
  
)

export default component.exports